import { useI18n } from "@/i18n";
import { Globe } from "lucide-react";

export default function LanguageSwitcher({ variant = "dark", className = "" }) {
  const { lang, setLang } = useI18n();

  const isDark = variant === "dark";
  const baseColor = isDark ? "text-white/85" : "text-[#203240]/80";
  const activeColor = isDark ? "text-white" : "text-[#B8956A]";
  const inactiveHover = "hover:text-[#B8956A]";

  return (
    <div data-testid="lang-switcher" className={`inline-flex items-center gap-2 ${className}`}>
      <Globe size={12} className={isDark ? "text-white/60" : "text-[#697585]"} />
      <button
        type="button"
        data-testid="lang-fr"
        onClick={() => setLang("fr")}
        aria-pressed={lang === "fr"}
        className={`text-[11px] uppercase tracking-[0.22em] transition-colors ${lang === "fr" ? activeColor : `${baseColor} ${inactiveHover}`}`}
      >
        FR
      </button>
      <span className={`text-[11px] ${isDark ? "text-white/30" : "text-[#697585]/50"}`}>·</span>
      <button
        type="button"
        data-testid="lang-en"
        onClick={() => setLang("en")}
        aria-pressed={lang === "en"}
        className={`text-[11px] uppercase tracking-[0.22em] transition-colors ${lang === "en" ? activeColor : `${baseColor} ${inactiveHover}`}`}
      >
        EN
      </button>
    </div>
  );
}
